import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Textfield from '@atlaskit/textfield';
export const EditNumber = ({
  id,
  value,
  isInvalid,
  isRequired,
  onChange
}) => {
  return (
    /*#__PURE__*/
    /* TODO (REQIN-1383): once this folder meets tangerine structure, label and title should be internationalised and placed in a messages.tsx file */
    React.createElement(Textfield, {
      id: id,
      value: value,
      isInvalid: isInvalid,
      isRequired: fg('proforma_a11y_mandatory_fields') ? isRequired : undefined,
      onChange: onChange,
      width: "small",
      label: "number",
      "aria-label": "number field",
      title: "number",
      placeholder: ""
    })
  );
};